export default __webpack_public_path__ + "static/media/map.2215cfb7.png";